import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { Stack } from '../../../../../primitives/index.js';
export const Content = /*#__PURE__*/_styled(Stack, process.env.NODE_ENV === "production" ? {
  target: "e1ox5m790"
} : {
  target: "e1ox5m790",
  label: "Content"
})(process.env.NODE_ENV === "production" ? {
  name: "13udsys",
  styles: "height:100%"
} : {
  name: "13udsys",
  styles: "height:100%/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRlbnQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRXFDIiwiZmlsZSI6IkNvbnRlbnQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBTdGFjayB9IGZyb20gJy4uLy4uLy4uLy4uLy4uL3ByaW1pdGl2ZXMvaW5kZXguanMnO1xuZXhwb3J0IGNvbnN0IENvbnRlbnQgPSBzdHlsZWQoU3RhY2spIGBcbiAgaGVpZ2h0OiAxMDAlO1xuYDtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPUNvbnRlbnQuanMubWFwIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});